import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { toast } from 'react-toastify'

interface sendNotificationArgs {
  message: string | undefined
  title: string | undefined
  token: string
  type: string
}

interface sendNotificationTopicArgs {
  message: string | undefined
  title: string | undefined
  topic: string
  type: string
  userId: string | undefined
}
export interface UserCredentialProvidersBackup {
  userId: string
  id: string
  moneyhubId: string
  yodleeSalt: string
  yodleeLoginName: string
  powensId: string
  powensToken: string
  profilePic: string
  createdAt: string
  updatedAt: string
  devices: Device[]
}
export type Device = {
  token: string
  deviceId: string
}

export const getUserCredentialBackup = createAsyncThunk<
  UserCredentialProvidersBackup,
  string
>('notifications_slice/getUserCredentialBackup', async (userId, thunkAPI) => {
  try {
    const res = await fetch(
      `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/bckp/account-backup?userId=${userId}`,
    )
    const data = await res.json()
    const payload = data.response.data as UserCredentialProvidersBackup[]
    return payload[0]
  } catch (e) {
    console.log('Error Fetching getUserCredentialBackup' + e)
    return thunkAPI.rejectWithValue(e)
  }
})

interface addToWaitlistArgs {
  email: string | undefined
  name: string | undefined
  sentence: string | undefined
}
interface AddToWaitlistResponse {
  id: string
  email: string
  created_at: string
  name: string
  sentence: string
}

// Define the structure for an error response
interface ErrorResponse {
  message: string
  error: string
}

export const addToWaitlist = createAsyncThunk<
  AddToWaitlistResponse | undefined,
  addToWaitlistArgs
>(
  'notifications_slice/addToWaitlist',
  async ({ email, name, sentence }, thunkAPI) => {
    //console.log('admin app frontend ', app)
    try {
      console.log('inputs', email, name, sentence)
      //http://127.0.0.1:5001/elisyanwealth/us-central1/addToWaitlist1
      const response = await axios.post(
        'https://us-central1-elisyanwealth.cloudfunctions.net/addToWaitlist1',
        {
          email: email,
          name: name,
          sentence: sentence,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      console.log('axios', response)
      return response.data
      /*
        const response = await addWaitListEntry(body);
        console.log("Waitlist entry added successfully:", response.data);
     */
      /*const waitlistCollection = collection(firestore, 'users');
     console.log('firestore', firestore)
     console.log('collection:::::::::::::::', waitlistCollection);
     //const newWaitlist = await addDoc(waitlistCollection, {...body});
     const newUser = {appUserId:
      '',
      
      email: 'souadm1@albisai.com',
      
      revenuCatId: '',
      
      
      role:
      'employee'}
     const newWaitlist = await addDoc(waitlistCollection, {...newUser});
     console.log('new waitlist created', newWaitlist)*/
      /* const usersRef = collection(firestore, "users");
    const querySnapshot = await getDocs(usersRef);

    const users = querySnapshot.docs.map(doc => doc.data());
    console.log(users);
     //return newWaitlist;*/
    } catch (e) {
      console.log('-------------- Error register User Device Token' + e)
      return thunkAPI.rejectWithValue(e as ErrorResponse)
    }
  },
)

export const sendNotification = createAsyncThunk<
  string | undefined,
  sendNotificationArgs
>(
  'notifications_slice/sendNotification',
  async ({ message, title, token, type }, thunkAPI) => {
    // console.log('messaging  get token ', token);
    try {
      const body = {
        message: {
          token: token,
          //"condition": `'enabled_push_notification' in topics`,
          data: {
            type: type,
          },
          notification: {
            body: message,
            title: title,
          },
        },
      }

      const response = await axios.post(
        'https://pushnotifications-c5yieuvjca-uc.a.run.app',
        body,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      console.log('axios', response)
    } catch (e) {
      console.log('-------------- Error register User Device Token' + e)
      return thunkAPI.rejectWithValue(e)
    }
  },
)

export const sendNotificationByTopic = createAsyncThunk<
  string | undefined,
  sendNotificationTopicArgs
>(
  'notifications_slice/sendNotification',
  async ({ message, title, topic, type }, thunkAPI) => {
    try {
      // type NotificationData = {
      //   type: string;
      //   body: string | undefined;
      //   title: string | undefined;
      //   userID?: string; // userID is optional
      // };

      const content = {
        topic: topic,
        //token: userId,

        notification: {
          title: title,
          body: message,
        },
        android: {
          priority: 'high',
        },
        apns: {
          payload: {
            aps: {
              'mutable-content': 1,
              'content-available': 1,
            },
          },
          headers: {
            'apns-priority': '10',
            'apns-topic': 'com.elisyanwealth.pwm',
          },
        },
        data: {
          type: type,
        },
      }

      /*
      const body = {
        "message":{
          "token": userId,
          "notification": {
              "title": "You have received a new request",
              "body": "Radiohead - Street Spirit (Fade Out)",
              //"content_available" : "true",
              //"priority" : "high",
              //"sound":"defualt",
              //"image": "https://i.ytimg.com/vi/LCJblaUkkfc/hq720.jpg"
          },
          "android": {
            "priority": "high",
          },
          "apns": {
            "payload": {
              "aps": {
                "mutable-content": "1",
                "content-available": "true",
              },
            },
            "headers": {
              "mutable-content": "1",
            // "apns-push-type": "background",
              "apns-priority": "10", 
              "apns-topic": "com.elisyanwealth.pwm" 
            }
          },
          "data":{
            "passingDataToApp" : "Mario",
            "body" : "great match!",
            "Room" : "PortugalVSDenmark"
          }
            // "to": userId,
            // //"topic": topic,
            // "notification": {
            //   body: message,
            //   title: title
            // },
            // "data" : data,
            // "android": {
            //   "priority": "high"  // Set priority to high for Android
            // },
            // "apns": {
            //   payload: {
            //       aps: {
            //         "content-available": true,
            //         //category: 'post', // A category that's already been created by your app
            //           // sound: 'media/kick.wav', // A local sound file you have inside your app's bundle
            //           //  ... // any other properties
            //       },
                  
            //   },
            //   headers: {
            //         "apns-push-type": "alert",  // For foreground notifications
            //         "apns-priority": "10",     // For immediate notifications
            //         'apns-topic': 'com.elisyanwealth.pwm', 
            //       },
        },  
      }*/
      const body = {
        message: content,
      }
      //https://pushnotifications-c5yieuvjca-uc.a.run.app
      //http://127.0.0.1:5001/elisyanwealth/us-central1/pushNotifications
      // const response = await axios.post('http://127.0.0.1:5001/elisyanwealth/us-central1/pushNotifications', body, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //   }});
      const response1 = await axios.post(
        'https://pushnotificationstopic-c5yieuvjca-uc.a.run.app',
        body,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      console.log('axios', response1)
      toast.success('Notification Sent successfully!')
    } catch (e) {
      console.log('-------------- Error sending Notification' + e)
      toast.error('Error while sending Notification:')
      return thunkAPI.rejectWithValue(e)
    }
  },
)

interface SendSpecificUserNotificationPayload {
  userId: string
  title: string
  message: string
  type: string
}

// export const sendNotificationToSpecificUserOld = createAsyncThunk<
//   any,
//   SendSpecificUserNotificationPayload,
//   { dispatch: AppDispatch; state: RootState }
// >(
//   'notification/sendNotificationToSpecificUser',
//   async ({ userId, title, message, type }, thunkAPI) => {
//     try {
//       // 1. Fetch the user device tokens directly
//       const res = await fetch(`https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/bckp/account-backup?userId=${userId}`);
//       const data = await res.json();
//       const payload = data.response.data as UserCredentialProvidersBackup[];

//       const deviceTokens = payload[0]?.devices?.map(device => device.token).filter(Boolean);

//       if (!deviceTokens || deviceTokens.length === 0) {
//         throw new Error('No device tokens found for this user.');
//       }

//       // 2. Construct and send the push notification
//       const notificationData = {
//         userID: userId,
//         type,
//         body: message,
//         title,
//       };

//       const body = {
//         message: {
//           tokens: deviceTokens,
//           data: notificationData,
//           android: {
//             priority: 'high',
//           },
//           apns: {
//             payload: {
//               aps: {
//                 'mutable-content': 1,
//                 'content-available': 1,
//               },
//             },
//             headers: {
//               'apns-priority': '10',
//               'apns-topic': 'com.elisyanwealth.pwm',
//             },
//           },
//         },
//       };

//       const response = await axios.post(
//         'http://127.0.0.1:5001/elisyanwealth/us-central1/pushNotificationsTokens1',
//         body,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         }
//       );

//       return response.data;
//     } catch (error) {
//       console.error('Error in sendNotificationToSpecificUser:', error);
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const sendNotificationToSpecificUser = createAsyncThunk<
  string | undefined,
  SendSpecificUserNotificationPayload
>(
  'notifications_slice/sendNotificationToSpecificUser',
  async ({ userId, title, message, type }, thunkAPI) => {
    try {
      const res = await fetch(
        `https://b14h7isg51.execute-api.eu-west-2.amazonaws.com/staging/bckp/account-backup?userId=${userId}`,
      )

      if (!res.ok) {
        const errorText = await res.text()
        console.error(`❌ Backup API Error ${res.status}: ${errorText}`)
        toast.error(`Failed to fetch user credentials. (${res.status})`)
        return thunkAPI.rejectWithValue(`HTTP ${res.status}: ${errorText}`)
      }

      const data = await res.json()

      const payload = data?.response?.data as UserCredentialProvidersBackup[]
      const devices = payload?.[0]?.devices || []

      if (!devices.length) {
        const msg =
          'This user has not enabled notifications on any of their devices.'
        toast.error(msg)
        return thunkAPI.rejectWithValue(msg)
      }

      const deviceTokens = devices.map((device) => device.token).filter(Boolean)

      const notificationData = {
        userID: userId,
        type,
        body: message,
        title,
      }

      const body = {
        message: {
          tokens: deviceTokens,
          data: notificationData,
          android: {
            priority: 'high',
          },
          apns: {
            payload: {
              aps: {
                'mutable-content': 1,
                'content-available': 1,
              },
            },
            headers: {
              'apns-priority': '10',
              'apns-topic': 'com.elisyanwealth.pwm',
            },
          },
        },
      }

      const response = await axios.post(
        // 'http://127.0.0.1:5001/elisyanwealth/us-central1/pushNotificationsTokens1',
        'https://pushnotificationstokens1-c5yieuvjca-uc.a.run.app',
        body,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )

      console.log('✅ Notification sent to specific user:', response.data)
      toast.success('Notification sent successfully!')
      return 'Notification sent successfully!'
    } catch (e) {
      let errorMsg = 'An unexpected error occurred.'
      if (axios.isAxiosError(e)) {
        errorMsg = e.response?.data?.error || e.message
      } else if (typeof e === 'string') {
        errorMsg = e
      } else if (e instanceof Error) {
        errorMsg = e.message
      }

      console.error('❌ Error sending notification to specific user:', e)
      toast.error(errorMsg)
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)
